import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as accessTokenInfo from "./accessToken";

import authInfo from './modules/auth'
import designation from './modules/designation'
import budget from './modules/budget'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
        
    },
    getters: {
        /*getAutocompleteList: state => {
            return state.autocomplete.data
        }*/
    },
    mutations: {
        changeLoader: state => {
            state.loading = !state.loading
        },
        setOverlayState: state => {
            state.pageOverlay = true
        },
        unsetOverlayState: state => {
            state.pageOverlay = false
        },
    },
    actions: {
        
    },
    modules: {
        authInfo, designation, budget
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js